import React, { useRef, useState } from "react";
import "./register.scss";
import { Link } from "react-router-dom";
import { registerValidation } from "../../utils/validation";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth } from "../../utils/firebase";
import { useDispatch } from "react-redux";
import { addUser } from "../../utils/store/slice/userSlice";

const Register = () => {
  const [isValidationError, setIsValidationError] = useState(null);
  const emailRef = useRef();
  const nameRef = useRef();
  const passwordRef = useRef();
  const confirmPassRef = useRef();
  const dispatch = useDispatch();

  const handleRegister = () => {
    const emailValue = emailRef.current.value;
    const nameValue = nameRef.current.value;
    const passwordValue = passwordRef.current.value;
    const confirmPasswordValue = confirmPassRef.current.value;
    const validationError = registerValidation(
      emailValue,
      passwordValue,
      confirmPasswordValue
    );
    setIsValidationError(validationError);
    if (validationError) return;

    createUserWithEmailAndPassword(auth, emailValue, passwordValue)
      .then((userCredential) => {
        const user = userCredential.user;
        updateProfile(user, {
          displayName: nameValue,
        }).then(() => {
          const { uid, email, displayName } = auth.currentUser;
          dispatch(
            addUser({ uid: uid, email: email, displayName: displayName })
          );
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        setIsValidationError(errorCode + "-" + errorMessage);
      });
  };

  return (
    <div className="register-section">
      <div className="register-content">
        <div className="register-text">
          <h1 className="register-title">Register</h1>
          <label className="label email">Name :</label>
          <input
            className="input adress"
            type="text"
            placeholder="Enter name"
            ref={nameRef}
            required
          ></input>
          <label className="label email">Email :</label>
          <input
            className="input adress"
            type="text"
            placeholder="Enter email"
            ref={emailRef}
            required
          ></input>
          <label className="label password">Password :</label>
          <input
            className="input pass"
            type="password"
            placeholder="Enter password"
            ref={passwordRef}
            required
          ></input>
          <label className="label password">Confirm Password :</label>
          <input
            className="input pass"
            type="password"
            placeholder="Enter correct password"
            ref={confirmPassRef}
            required
          ></input>
          <p className="text-red-600 text-left">{isValidationError}</p>
          <button className="btn mt-9 mb-4" onClick={handleRegister}>
            Register
          </button>

          <p>Already a user?</p>
          <Link to="/login">
            <button style={{ textDecoration: "none" }} className="btn login">
              Log in
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
